"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedInterleavedCircle2dQuadIndexerFactory = void 0;
const shared_interleaved_point_2d_quad_indexer_1 = require("./shared-interleaved-point-2d-quad-indexer");
/**
 * @public
 * Creates a {@link ISharedInterleavedPoint2dQuadIndexer} for capless circles.
 */
class SharedInterleavedCircle2dQuadIndexerFactory {
    static createOneF32(wrapper) {
        return shared_interleaved_point_2d_quad_indexer_1.SharedInterleavedPoint2dQuadIndexer.createOne(wrapper, "f32Interleaved2dCircleQuadIndexer", Float32Array);
    }
    static createOneF64(wrapper) {
        return shared_interleaved_point_2d_quad_indexer_1.SharedInterleavedPoint2dQuadIndexer.createOne(wrapper, "f32Interleaved2dCircleQuadIndexer", Float64Array);
    }
}
exports.SharedInterleavedCircle2dQuadIndexerFactory = SharedInterleavedCircle2dQuadIndexerFactory;
//# sourceMappingURL=shared-interleaved-circle-2d-quad-indexer-factory.js.map